/**
 * voiceApi.ts
 *
 * API functions for the Voice Profile feature.
 *
 * Endpoints:
 *   GET  /api/voice/settings            — list caller's preferred posts
 *   POST /api/voice/preferred-posts     — add a preferred post
 *   DELETE /api/voice/preferred-posts/:id — remove a preferred post
 *   POST /api/voice/fetch-url           — extract post text from a LinkedIn URL
 *
 * Rollback: remove this file + all import sites (VoiceProfilePage, routes/index.tsx).
 */

import api from './config';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface PreferredPost {
  id:               number;
  excerpt:          string;
  source_url:       string | null;
  engagement_score: number;
  created_at:       string;
}

export interface FetchUrlResult {
  text:    string;
  success: boolean;
  source:  'jina' | 'og' | 'failed';
}

// ── API functions ─────────────────────────────────────────────────────────────

export const getVoiceSettingsApi = async (): Promise<{ preferredPosts: PreferredPost[] }> => {
  const response = await api.get('/api/voice/settings');
  return response.data;
};

export const addPreferredPostApi = async (
  payload: { text: string; url?: string }
): Promise<{ id: number; excerpt: string; source_url: string | null }> => {
  const response = await api.post('/api/voice/preferred-posts', payload);
  return response.data;
};

export const deletePreferredPostApi = async (id: number): Promise<{ ok: boolean }> => {
  const response = await api.delete(`/api/voice/preferred-posts/${id}`);
  return response.data;
};

/** Unauthenticated — extracts text from a public LinkedIn URL via Jina + og fallback. */
export const fetchPostFromUrlApi = async (url: string): Promise<FetchUrlResult> => {
  const response = await api.post('/api/voice/fetch-url', { url });
  return response.data;
};
